import { fetchUser } from "../../../../redux/features/user/userSlice";
import {
  setSandboxError,
  switchBackFromSandbox,
  switchToSandbox,
} from "./sandboxSlice";
import {
  clearSandboxAccessRecoveryMark,
  hasSandboxAccessRecoveryMark,
  hasSandboxSessionMark,
  setSandboxAccessRecoveryMark,
  setSandboxSessionMark,
} from "./sandboxSession";

export function isSandboxAccessDenied(error) {
  const status = error?.status ?? error?.payload?.status;
  if (status === 403) return true;
  const message =
    (typeof error === "string" && error) ||
    error?.message ||
    error?.payload?.message ||
    "";
  return (
    typeof message === "string" &&
    message.toLowerCase().includes("don't have access")
  );
}

export async function recoverLiveCompanyIfSandboxDenied(dispatch) {
  if (hasSandboxAccessRecoveryMark()) {
    return false;
  }

  setSandboxAccessRecoveryMark();
  try {
    await dispatch(switchBackFromSandbox());
  } catch {
    if (hasSandboxSessionMark()) {
      setSandboxSessionMark(true);
    }
    return false;
  }
  window.location.reload();
  return true;
}

export async function switchSandboxSession(dispatch, { switchBack = false } = {}) {
  await dispatch(switchBack ? switchBackFromSandbox() : switchToSandbox());

  if (switchBack) {
    clearSandboxAccessRecoveryMark();
    window.location.reload();
    return;
  }

  try {
    await dispatch(fetchUser());
  } catch (error) {
    try {
      await dispatch(switchBackFromSandbox());
      await dispatch(fetchUser());
    } catch {
      setSandboxSessionMark(false);
    }
    const message = isSandboxAccessDenied(error)
      ? "This sandbox does not have access to the current app. Switched back to the live company."
      : error?.message || error?.payload?.message || "Error";
    dispatch(setSandboxError(message));
    throw new Error(message);
  }

  clearSandboxAccessRecoveryMark();
  window.location.reload();
}
